import { isVoucherPayMode, paymentChangeAmount, PayModeEnum } from '../../util/constants';

import { addMoney } from "../../util/quantity";
export type VoucherTenderLine = {
  id: number;
  code: string;
  amount: number;
  remaining: number;
  issued?: string | null;
  expiry?: string | null;
  spend: number;
};

export const voucherTenderTotal = (lines: VoucherTenderLine[]) =>
  lines.reduce((sum, line) => addMoney(sum, Math.max(0, Number(line.spend) || 0)), 0);

export const voucherModeId = (modes: { id: number | string }[]) => {
  const match = modes.find((mode) => isVoucherPayMode(mode.id));
  return String(match?.id ?? PayModeEnum.VOUCHER);
};

export const expandPaymentEntries = (
  entries: [string, { enabled?: boolean; amount?: number; received?: number; vouchers?: VoucherTenderLine[] }][],
  extras: Record<string, unknown>,
  options?: { includeChange?: boolean },
) => {
  const payments: Record<string, unknown>[] = [];
  for (const [modeId, payment] of entries) {
    if (!payment?.enabled || Number(payment.amount || 0) <= 0) continue;
    if (isVoucherPayMode(modeId) && payment.vouchers?.length) {
      for (const line of payment.vouchers) {
        const spend = Math.max(0, Number(line.spend) || 0);
        if (spend <= 0) continue;
        payments.push({
          ...extras,
          amount: spend,
          mode: Number(modeId),
          voucher: line.id,
          voucher_code: line.code,
        });
      }
      continue;
    }
    const change = options?.includeChange ? paymentChangeAmount(payment) : 0;
    payments.push({
      ...extras,
      amount: Number(payment.amount || 0),
      mode: Number(modeId),
      ...(change > 0 ? { received: Number(payment.received || 0), change } : {}),
    });
  }
  return payments;
};
